export const STATUS_ICON_CONFIG_MAP: Record<
    string,
    {icon: string | null; status: string | null; label: string | null; commentBox?: boolean}
> = {
    STARTED: {icon: null, status: null, label: null},
    UPLOADED: {icon: 'clock-outline', status: 'warning', label: 'In Progress'},
    CREATED: {icon: 'clock-outline', status: 'warning', label: 'Created'},
    ACTIVE: {icon: 'checkmark-circle-2-outline', status: 'basic', label: 'Waiting for Data'},
    EXECUTED: {icon: 'clock-outline', status: 'warning', label: 'Executed'},
    VALID: {icon: 'checkmark-circle-2-outline', status: 'success', label: 'Success'},
    SUCCESS: {icon: 'checkmark-circle-2-outline', status: 'success', label: 'Success'},
    SUCCESS_WITH_WARNING: {icon: 'checkmark-circle-2-outline', status: 'success', label: 'Success With Info'},
    PARTIAL_SUCCESS: {icon: 'checkmark-circle-2-outline', status: 'success', label: 'Partial Success'},
    INVALID: {icon: 'close-circle-outline', status: 'danger', label: 'Failed'},
    FAILED: {icon: 'close-circle-outline', status: 'danger', label: 'Failed'},
    PENDING_DELETE: {icon: 'close-circle-outline', status: 'basic', label: 'Pending Delete'},
    DELETED: {icon: 'close-circle-outline', status: 'basic', label: 'Deleted'},
    NEW: {icon: 'plus-circle-outline', status: 'new', label: 'New'},
    PROCESSED: {icon: 'checkmark-circle-2-outline', status: 'basic', label: 'Processed'},
    NONE: {icon: 'minus-square-outline', status: 'unselected', label: ''},
    UNSELECTED: {icon: 'minus-square-outline', status: 'unselected', label: ''},
    ACCEPTED: {icon: 'checkmark-square-2-outline', status: 'accepted', label: ''},
    REJECTED: {icon: 'close-square-outline', status: 'rejected', label: ''},
    ORIGINAL_COMMENT: {icon: 'message-square-outline', status: 'empty-message', label: '', commentBox: false},
    UPDATED_COMMENT: {icon: 'message-square-outline', status: 'message', label: '', commentBox: true},
    IN_PROCESS: {icon: 'clock-outline', status: 'warning', label: 'In Progress'},
    PUBLISHED: {icon: 'checkmark-circle-2-outline', status: 'success', label: 'Published'},
    READY_FOR_PUBLISH: {icon: 'checkmark-circle-2-outline', status: 'new', label: 'Ready for publish'},
    OPEN: {icon: 'clock-outline', status: 'warning', label: 'Open'},
    IN_PROGRESS: {icon: 'clock-outline', status: 'warning', label: 'In Progress'},
    RESOLVED: {icon: 'checkmark-circle-2-outline', status: 'success', label: 'Resolved'},
    COMPLETED: {icon: 'checkmark-circle-2-outline', status: 'success', label: 'Completed'},
    ALERT: {icon: 'alert-triangle-outline', status: 'warning', label: ''},
    PENDING_REVIEW: {icon: 'clock-outline', status: 'warning', label: 'Pending Review'},
    CORRECTED: {icon: 'edit-2-outline', status: 'basic', label: 'Corrected'},
    APPROVED: {icon: 'checkmark-square-2-outline', status: 'accepted', label: 'Approved'},
    DEFAULT: {icon: 'close-circle-outline', status: 'basic', label: 'unknown'},
    ERRORS_FOUND: {icon: 'close-circle-outline', status: 'danger', label: 'Errors_found'},
    HAS_WARNINGS: {icon: 'close-circle-outline', status: 'danger', label: 'Errors Found'},
};
